/* TypeScript file generated from HelpCenter.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as HelpCenterJS from './HelpCenter.res.js';

export const install: (appId:string) => void = HelpCenterJS.install as any;
